'use client';
import Button from '@src/v3/components/coreUI/button';
import { ReadonlyURLSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../popover';

interface Locations {
  value: string;
}

const Locations = ({
  searchParams,
}: {
  searchParams: ReadonlyURLSearchParams;
}) => {
  const [locations, setLocations] = useState<Locations[]>([]);

  useEffect(() => {
    if (searchParams) {
      const loc = getSearchDefaultValue(searchParams);

      setLocations(loc);
    }
  }, [searchParams]);

  /**
   * A function to get the default value for search.
   *
   * @return {type} description of return value
   */
  const getSearchDefaultValue = (
    searchParams: ReadonlyURLSearchParams | null
  ) => {
    const neighborhood = searchParams?.get('neighborhood');
    const zipCode = searchParams?.get('zip_code');
    const addressLabel = searchParams?.get('address_label');

    if (zipCode) {
      const zipCodes = zipCode.split('|');
      return zipCodes.map((zip: string) => ({
        value: zip,
      }));
    }

    if (neighborhood) {
      const neighborhoods = neighborhood.split('|');
      return neighborhoods.map((neighborhood: string) => ({
        value: neighborhood,
      }));
    }

    if (addressLabel) {
      return [
        {
          value: addressLabel,
        },
      ];
    }

    return [];
  };

  return (
    <div className="m-3 flex gap-x-3">
      <Button
        variant="outline"
        className="inline-flex h-11 p-4 text-base font-medium justify-center items-center gap-2 shrink-0 rounded-[100px] border border-[#E5E7EB] bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] shadow-md"
      >
        <span className="h-2 w-2 rounded-full bg-primary-dark"></span>
        {locations?.length > 0 ? locations[0].value : 'New York City, NY'}
      </Button>
      {locations?.length > 1 && (
        <Popover>
          <PopoverTrigger asChild>
            <Button
              size="xs"
              className="flex cursor-pointer text-black-dark w-11 h-11 p-4 text-base font-medium justify-center items-center gap-2 shrink-0 rounded-[100px] border border-[#0072F5] bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] shadow-md"
              onClick={(e) => e.stopPropagation()}
              title="+1"
            >
              +1
            </Button>
          </PopoverTrigger>
          <PopoverContent
            className="w-auto max-w-[300px] p-3 flex flex-col gap-y-2 rounded-xl"
            align="start"
            side="bottom"
            sideOffset={4}
          >
            {locations?.map((location, index) => {
              if (index === 0) return null;
              return (
                <div
                  key={index}
                  className="flex px-3 py-2 text-sm text-gray-1000 font-medium items-center gap-2 rounded bg-primary-lighter"
                >
                  {location.value}
                </div>
              );
            })}
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};

export default Locations;
